import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useInventoryServiceLevel } from '@features/inventory';
import { APP_CONFIG } from '../../../../config/app.config';
import DashboardCardHeader from '../general/DashboardCardHeader';
import DashboardCardContent from '../general/DashboardCardContent';
import { ProductFilter } from '@domain/product/models/ProductFilter';

export const DASHBOARD_PRODUCT_FILTER: ProductFilter = {
  purchasable: true,
  active: true,
};

const ServiceLevelKpiCard: React.FC = () => {
  const colors = APP_CONFIG.ui.theme.colors;
  const { serviceLevel, isLoading } = useInventoryServiceLevel(
    DASHBOARD_PRODUCT_FILTER,
  );
  const serviceLevelPercent = serviceLevel?.serviceLevelPercent ?? null;

  return (
    <Stack minWidth={0} overflow="hidden" height="100%">
      <DashboardCardHeader icon="AnnotationCheck" title="Service Level" />
      <DashboardCardContent>
        {isLoading && !serviceLevel ? (
          <Stack alignItems="center" justifyContent="center" height={58}>
            <CircularProgress size={20} />
          </Stack>
        ) : (
          <>
            <Stack direction="row" alignItems="center" gap={1} height={42}>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: 28,
                  lineHeight: '36px',
                  color: colors.primaryText,
                }}
              >
                {serviceLevelPercent != null ? `${serviceLevelPercent}%` : '—'}
              </Typography>
            </Stack>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: 10,
                lineHeight: '16px',
                letterSpacing: '0.5px',
                color: colors.secondaryText,
              }}
            >
              Weeks in stock over the last 52 weeks
            </Typography>
          </>
        )}
      </DashboardCardContent>
    </Stack>
  );
};

export default ServiceLevelKpiCard;
